import { EpimsBaseEntityDto } from './epim-base.dto';
export class PipelineLicenseCategoryDto extends EpimsBaseEntityDto {

    PipelineLicenseCategoryId: string;

    PipelineLicenseCategoryName: string;
    EstimatedDuration: number;
    SubscriptionUserId: string;
}